import React from 'react';

import { styled, useTheme } from '@mui/material/styles';
import { LinearProgress, Theme } from '@mui/material';

const Container = styled('div')({
   width: '100%',
});

const useStyles = (theme: Theme) => ({
  root: {
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
});

export default () => {
  const classes = useStyles(useTheme());

  return (
    <Container sx={classes.root}>
      <LinearProgress color='secondary' />
    </Container>
  );
}